export default "__VITE_ASSET__B$j5OwnB__"